import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "convertupleads-theme";

const BasicTable = () => {
  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>type</TableCell>
              <TableCell>cost</TableCell>
              <TableCell align={"center"}>inbound/outbound</TableCell>
              <TableCell>created at</TableCell>
              <TableCell>action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Outgoing Call</TableCell>
              <TableCell>$0.0045</TableCell>
              <TableCell align="center">Out</TableCell>
              <TableCell>today</TableCell>
              <TableCell>send</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Outgoing Call</TableCell>
              <TableCell>$0.0045</TableCell>
              <TableCell align="center">Out</TableCell>
              <TableCell>today</TableCell>
              <TableCell>send</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Outgoing Call</TableCell>
              <TableCell>$0.0045</TableCell>
              <TableCell align="center">Out</TableCell>
              <TableCell>today</TableCell>
              <TableCell>send</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Outgoing Call</TableCell>
              <TableCell>$0.0045</TableCell>
              <TableCell align="center">Out</TableCell>
              <TableCell>today</TableCell>
              <TableCell>send</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Outgoing Call</TableCell>
              <TableCell>$0.0045</TableCell>
              <TableCell align="center">Out</TableCell>
              <TableCell>today</TableCell>
              <TableCell>send</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default BasicTable;
